import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { guides } from "@/data/guides";

const Guides = () => (
  <div className="bg-white" data-testid="guides-page">
    <Seo
      title="Guides Fast Alu | Conseils vitrage, pose, profilés"
      description="Guides pratiques pour vos projets alu/métal : vitrage, pose en rénovation, profilés REHO."
    />
    <section className="bg-brand-blue/5" data-testid="guides-hero">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl uppercase" data-testid="guides-title">
          Guides & conseils
        </h1>
        <p className="text-brand-ink/70 mt-4" data-testid="guides-subtitle">
          Ressources utiles pour comprendre vos travaux aluminium, métallerie et vitrage.
        </p>
      </div>
    </section>
    <section className="max-w-6xl mx-auto px-6 py-16" data-testid="guides-list">
      <div className="grid md:grid-cols-2 gap-6">
        {guides.map((guide) => (
          <div
            key={guide.slug}
            className="border border-brand-blue/15 rounded-sm p-6 bg-white"
            data-testid={`guide-card-${guide.slug}`}
          >
            <Link to={`/guides/${guide.slug}`} data-testid={`guide-image-link-${guide.slug}`}>
              <img
                src={guide.image}
                alt={guide.title}
                className="w-full h-40 object-cover rounded-sm"
                data-testid={`guide-image-${guide.slug}`}
              />
            </Link>
            <h2 className="font-heading text-2xl uppercase mt-4" data-testid={`guide-title-${guide.slug}`}>
              {guide.title}
            </h2>
            <p className="text-sm text-brand-ink/70 mt-2" data-testid={`guide-excerpt-${guide.slug}`}>
              {guide.excerpt}
            </p>
            <Link
              to={`/guides/${guide.slug}`}
              className="inline-flex mt-4 text-xs uppercase font-semibold text-brand-red"
              data-testid={`guide-link-${guide.slug}`}
            >
              Lire le guide
            </Link>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default Guides;
